export default __webpack_public_path__ + "static/media/Holicef-1-gm-IM-ban.1a46b544.jpg";